import monochromeIcon from "../../icons/monochromeIcon.svg"
import lowSaturationIcon from "../../icons/lowSaturationIcon.svg"
import highSaturationIcon from "../../icons/highSaturationIcon.svg"
import lightContrastIcon from "../../icons/lightContrastIcon.svg"
import darkContrastIcon from "../../icons/darkContrastIcon.svg"
import highContrastIcon from "../../icons/highContrastIcon.svg"
import protanopiaIcon from "../../icons/protanopiaIcon.svg"
import deuteranopiaIcon from "../../icons/deuteranopiaIcon.svg"
import tritanopiaIcon from "../../icons/tritanopiaIcon.svg"

export default [
    {
        label: 'Monochrome',
        key: 'monochrome',
        icon: monochromeIcon,
    },
    {
        label: 'Low Saturation',
        key: 'low-saturation',
        icon: lowSaturationIcon,
    },
    {
        label: 'High Saturation',
        key: 'high-saturation',
        icon: highSaturationIcon,
    },
    {
        label: 'High Contrast',
        key: 'high-contrast',
        icon: highContrastIcon,
    },
    {
        label: 'Light Contrast',
        key: 'light-contrast',
        icon: lightContrastIcon,
    },
    {
        label: 'Dark Contrast',
        key: 'dark-contrast',
        icon: darkContrastIcon,
    },
    /*
    {
        label: 'Protanopia',
        key: 'protanopia',
        icon: protanopiaIcon,
    },
    {
        label: 'Deuteranopia',
        key: 'deuteranopia',
        icon: deuteranopiaIcon,
    },
    {
        label: 'Tritanopia',
        key: 'tritanopia',
        icon: tritanopiaIcon,
    }
        */
];